import React from 'react';
import {FormDialog} from 'components/core';
import {ProceduresCtx} from 'components/dataProviders/procedures';
import {TemplatesCtx} from 'components/dataProviders/procedureTemplates';


export default function CreateProcedureDialog({open, handleClose=()=>{}, onConfirm=()=>{}})
{
    const [loading, setLoading] = React.useState(false);
    const [templates, setTemplates] = React.useState([]);

    const procsCtx = React.useContext(ProceduresCtx);
    const templatesCtx = React.useContext(TemplatesCtx);


    React.useEffect(function initializeTags() {
      let templateItems = [{value: -1, content: "Sin plantilla"}];
      templatesCtx.data.array.forEach((item) => templateItems.push({value: item.templateID, content: item.name}));

      setTemplates(templateItems);
  }, [templatesCtx]);

    const handleNewDialogConfirm = (values) => {

      setLoading(true);
      
      if(values.templateID < 0) values.templateID = null;
      values = {name: "", description: "", tags: [], items: [], ...values};

      procsCtx.funcs.create(values).then((newProcedure) => {
        onConfirm(newProcedure.procedureID);
        setLoading(false);
        handleClose(); 
      });
    }


    return <FormDialog
      open={open}
      onClose={handleClose}
      onConfirm={handleNewDialogConfirm}
      title="Nuevo Procedimiento"      
      confirm="Crear Procedimiento"
      loading={loading}
      fields={[
        {
          type: "text",
          label: "Nombre",
          id: "name",
          placeholder: "Nombre del procedimiento",
          mandatory: true,
          value: ''
        },
        {
          type: "selector",
          label: "Plantilla",
          id: "templateID",
          placeholder: "Sin plantilla",
          mandatory: false,
          value: -1,
          items: templates
        }
      ]}
      />
}
